import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_FORWARDERS = "fetchForwarders";
export const FETCH_FORWARDER = "fetchForwarder";
export const SAVE_FORWARDER = "saveForwarder";
export const UPDATE_FORWARDER = "updateForwarder";
export const DELETE_FORWARDER = "deleteForwarder";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingForwarder";
export const SET_FORWARDERS = "setForwarders";

const state = {
  errors: [],
  forwarders: [],
  isLoadingForwarder: false
};

const getters = {
  isLoadingForwarder() {
    return state.isLoadingForwarder;
  },
  getForwarders() {
    return state.forwarders;
  }
};

const actions = {
  [FETCH_FORWARDERS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("forwarders" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_FORWARDER](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("forwarders", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_FORWARDER](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("forwarders", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_FORWARDER](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("forwarders", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_FORWARDER](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("forwarders", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingForwarder = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingForwarder = value;
  },
  [SET_FORWARDERS](state, data) {
    state.isLoadingForwarder = false;
    state.forwarders = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};